import * as Yup from 'yup';

const headers = [
  {
    label: 'Brand',
    id: 'brand_name'
  },
  {
    label: 'Name',
    id: 'full_name'
  },
  {
    label: 'Email',
    id: 'email'
  },
  {
    label: 'Phone',
    id: 'mobile_phone',
    phone: true
  },
  {
    label: 'Address',
    id: 'address'
  },
  {
    label: "Balance",
    balance: true,
    id: "balance"
  },
  // {
  //   label: "Wallet",
  //   currency: true,
  //   id: "wallet"
  // },
  {
    label: "Active",
    id: "is_active",
    boolean: true,
    values: ["Active", "Inactive"]
  }
];

const filters = [
  {
    id: "is_active",
    type: "boolean",
    label: "Active",
  },
  {
    id: "balance",
    type: "balance",
    label: "Balance",
  },
  {
    id: "wallet",
    type: "balance",
    label: "Wallet",
  },
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "company_name",
    label: "Company Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "brand_name",
    label: "Brand",
    type: "text",
    helperText: "This field cannot be changed after the initial setup",
    checkDisabled: (values) => values?.vendor_id,
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "divider",
    header: "Personal Details",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "first_name",
    label: "First Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "last_name",
    label: "Last Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "email",
    label: "Email",
    type: "email",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "mobile_phone",
    label: "Mobile Phone",
    type: "phone",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "home_phone",
    label: "Home Phone",
    type: "phone",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "divider",
    header: "Address Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "address",
    label: "Address",
    type: "text",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "city",
    label: "City",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "state",
    label: "State",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "zip",
    label: "Zip",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "country",
    label: "Country",
    type: "text",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "divider",
    header: "Account Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "wholesale_vendor",
    label: "This is a Wholesale Vendor",
    type: "checkbox",
    size: {xs: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "does_repairs",
    label: "Vendor Does Repairs",
    type: "checkbox",
    size: {xs: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "notes",
    label: "Notes",
    type: "text",
    multiline: true,
    rows: 4,
    size: {xs: 12, lg: 8},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_active",
    label: "Active",
    type: "checkbox",
    size: {xs: 12, lg: 4},
  }
]

const initialValues = {
  company_name: '',
  brand_name: '',
  first_name: '',
  last_name: '',
  email: '',
  mobile_phone: '',
  home_phone: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  is_active: true,
  wholesale_vendor: true,
  does_repairs: false
}

const schema = Yup.object().shape({
  company_name: Yup.string(),
  brand_name: Yup.string().when("wholesale_vendor", {
    is: true,
    then: (schema) => schema.required("Brand Name is required")
  }),
  first_name: Yup.string().required('First Name is required'),
  last_name: Yup.string().nullable(),
  email: Yup.string().email('Invalid email address').nullable(),
  mobile_phone: Yup.string().nullable(),
  home_phone: Yup.string().nullable(),
  address: Yup.string().nullable(),
  city: Yup.string().nullable(),  
  state: Yup.string().nullable(),
  zip: Yup.string().nullable(),
  country: Yup.string().nullable(),
  is_active: Yup.boolean(),
  wholesale_vendor: Yup.boolean().required("Please select if vendor is a wholesale vendor"),
  does_repairs: Yup.boolean().required("Please select if vendor does repairs")
});

export { headers, filters, fields, schema, initialValues };